import React, { ReactNode, FunctionComponent } from 'react'

export interface Props {
  title: string
  children: ReactNode
  gridClass?: string
  selected?: boolean
}

export const TradelineSelectionCard: FunctionComponent<Props> = ({
  title,
  gridClass,
  children,
}) => {
  return (
    <div className={`tradeline-selection-card ${gridClass || null}`}>
      <div className="tradeline-selection-card__header">
        <h2 className="tradeline-selection-card__title">
          {String(title).toUpperCase()}
        </h2>
      </div>
      <div className="tradeline-selection-card__body">{children}</div>
    </div>
  )
}

TradelineSelectionCard.displayName = 'TradelineSelectionCard'
